if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.initSlider();
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        autoHeight: true,
      });
    }
  }

  customElements.define('hero-slider', HeroSlider);
}
